import { render, staticRenderFns } from "./CustomerStatusDisplay.vue?vue&type=template&id=07a12b47&scoped=true"
import script from "./CustomerStatusDisplay.vue?vue&type=script&lang=js"
export * from "./CustomerStatusDisplay.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatusDisplay.vue?vue&type=style&index=0&id=07a12b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a12b47",
  null
  
)

export default component.exports